/*** IMPORTS FROM imports-loader ***/
var define = false;

(function ($, window, document, undefined) {
  $(document).ready(function () {
    const $BODY = $('[data-js-hook="body"]');
    const $NAV = $('[data-js-hook="nav"]');
    const $NAV_TOGGLE = $('[data-js-hook="navToggle"]');
    const $NAV_BAR = $('[data-js-hook="navBar"]');
    const $BRAND_LOGO = $('[data-js-hook="brandLogo"]');

    const $HEADER = $('[data-js-hook="header"]');
    const $MAIN_CONTENT = $('[data-js-hook="mainContent"]');
    const $FOOTER = $('[data-js-hook="footer"]');
    const $NAV_COLORS = Array(
      'gold',
      'blue',
      'punch',
      'green',
      'orange'
    );

    let logoStyle = '';

    $NAV
      .css({ 'visibility': 'hidden' })
      .niceScroll({
        cursorcolor: 'transparent',
        cursorborder: 'transparent',
        autohidemode: 'hidden',
        emulatetouch: true,
        grabcursorenabled: false
      });
    /**
     * Watch for click events on the navigation toggle. This will show or hide
     * the navigation overlay as well as update aria-* attributes for accessibility.
     */
    $NAV_TOGGLE.on('click keypress', function (e) {
      $NAV.toggleClass('nav--opened');
      $NAV.attr('data-color-background', $NAV_COLORS[Math.floor(Math.random() * $NAV_COLORS.length)]);
      // Since the navigation is an overlay, the following areas need to be
      // "hidden" so any screen readers or assistive technologies ignoere them.
      $HEADER.attr('aria-hidden', $HEADER.attr('aria-hidden') === 'true' ? false : true);
      $MAIN_CONTENT.attr('aria-hidden', $MAIN_CONTENT.attr('aria-hidden') === 'true' ? false : true);
      $FOOTER.attr('aria-hidden', $FOOTER.attr('aria-hidden') === 'true' ? false : true);

      // Navigation is open, close it.
      if ($NAV.data('open')) {
        $NAV.attr('aria-hidden', true);

        $NAV_TOGGLE.attr('aria-expanded', false);

        $BODY
          .clearQueue()
          .delay(250)
          .queue(function () {
            $(this)
              .removeClass('page--nav-opened')
              .css({ 'overflow-y': 'auto' });

            // After the nav is closed, reapply the logoStyle to the logo
            $BRAND_LOGO.attr('style', logoStyle);

            $NAV_BAR.css({ 'zIndex': '' });

            $NAV.css({ 'visibility': 'hidden' });
          })
          .unbind('keyup');
      }

      // Navigation is closed, open it.
      else {
        // Copy the logo styles and remove them.
        logoStyle = $BRAND_LOGO.attr('style');
        $BRAND_LOGO.attr('style', '');

        $NAV
          .attr('aria-hidden', false)
          .css({ 'visibility': '' });
        $NAV_TOGGLE.attr('aria-expanded', true);
        $NAV_BAR.css({ 'zIndex': ($NAV.css('zIndex') / 1) + 1 });

        $BODY
          .addClass('page--nav-opened')
          .clearQueue()
          .delay(200)
          .queue(function () {
            $(this).css({ 'overflow-y': 'hidden' });

            if (e.type == 'keypress' && e.which == 13) {
              // Make the first a tag focusable to the user.
              $NAV.find('a').first().focus();
            }
          })
          .bind('keyup', function (e) {
            if (e.keyCode == 27) {
              $NAV_TOGGLE.trigger('click');
            }
          });
      }

      // Swap the data-open attribute true = false / false = true.
      $NAV.data('open', !$NAV.data('open'));

      return false;
    });
  });
})(jQuery, window, document);
